import { useEffect } from "react";
import { useAppSelector } from "State/hooks";

const TitledRoute = ({ title, children }) => {
  const user = useAppSelector((state) => state.user.authData);
  // Set the title of the browser tab
  useEffect(() => {
    if (!user) {
      document.title = "Lilli";
    }
    document.title = `Lilli - ${title}`;
  }, [title, user]);
  return children;
};

export default TitledRoute;
